import { Account } from "@/model";

export default class AccountDatesConfig {
    constructor(json) {
      this.account = json.account ? Account.fromUuid(json.account) : undefined;
      this.displayName = json.displayName || (json.account ? json.account.name : "");
      const datesStr = json.dateRange ? JSON.parse(json.dateRange) : [];
      this.dateRange = datesStr.map(dstr => new Date(dstr));
    }
  
    toJson() {
      return {
        account: this.account.uuid,
        displayName: this.displayName,
        dateRange : JSON.stringify(this.dateRange.map(d => d.toISOString().substr(0, 10)))
      }
    }
  }
  